import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7f04d36b"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["onClick"];
const _hoisted_2 = {
    key: 0,
    class: "selected"
};
const _hoisted_3 = { class: "menu" };
const _hoisted_4 = { class: "menu--icon" };
const _hoisted_5 = { class: "display" };
import Badge from '@/materials/atoms/Badge.vue';
import MaterialIcon from '@/materials/atoms/MaterialIcon.vue';
import { useMessage } from '@/const/messages';
import { useStore } from '@/store/store';
import { MYPAGE_DASHBOARD, MYPAGE_API_MANAGEMENT, MYPAGE_MESSAGE } from './types';
import { useNotification } from '@/logics/notification';
export default /*#__PURE__*/ _defineComponent({
    props: {
        current: null
    },
    emits: ["click"],
    setup(__props, { emit: emits }) {
        const props = __props;
        const store = useStore();
        const { unreadCount } = useNotification();
        const onClick = (value) => emits('click', value);
        const { MYPAGE_MENU, format } = useMessage();
        const menus = [
            {
                icon: 'home',
                tab: MYPAGE_DASHBOARD,
                display: MYPAGE_MENU.DASHBOARD,
            },
            {
                icon: 'key',
                tab: MYPAGE_API_MANAGEMENT,
                display: MYPAGE_MENU.API_MANAGEMENT,
            },
            {
                icon: 'notifications',
                tab: MYPAGE_MESSAGE,
                display: MYPAGE_MENU.MYPAGE_MESSAGE,
            },
        ];
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("nav", null, [
                _createElementVNode("ul", {
                    class: _normalizeClass({ 'fixed-menu': _unref(store).state.isSmartPhone })
                }, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(menus, (menu) => {
                        return _createElementVNode("li", {
                            key: menu.tab,
                            class: _normalizeClass({ selectli: props.current === menu.tab }),
                            onClick: ($event) => (onClick(menu.tab))
                        }, [
                            (!_unref(store).state.isSmartPhone && props.current === menu.tab)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_2))
                                : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_3, [
                                _createElementVNode("span", _hoisted_4, [
                                    (menu.tab === _unref(MYPAGE_MESSAGE) && _unref(unreadCount) > 0)
                                        ? (_openBlock(), _createBlock(Badge, {
                                            key: 0,
                                            "color-mode": "error",
                                            class: "menu--icon--badge"
                                        }))
                                        : _createCommentVNode("", true),
                                    _createVNode(MaterialIcon, {
                                        name: menu.icon,
                                        class: "icon"
                                    }, null, 8, ["name"])
                                ]),
                                _createElementVNode("b", _hoisted_5, _toDisplayString(_unref(format)(menu.display)), 1)
                            ])
                        ], 10, _hoisted_1);
                    }), 64))
                ], 2)
            ]));
        };
    }
});
